import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconMessage } from '../../../../../assets/images/icons/icon_message.svg';
import { ReactComponent as IconPhone } from '../../../../../assets/images/icons/icon_phone.svg';
import { ReactComponent as IconWarranty } from '../../../../../assets/images/icons/icon_warranty.svg';
import styles from '../../../ProductDetails.module.scss';
import ValuePropsBox from '../ValuePropsBox';
import { showNanoVariant } from '../../../../../components/NanoBanner/NanoBanner';
import * as types from '../../../../../types';
import { useSelector } from 'react-redux';

interface MembershipValuePropsProps {
  inAppManagementVariant?: boolean;
}

export default function MembershipValueProps({ inAppManagementVariant = false }: MembershipValuePropsProps) {
  const { t } = useTranslation();
  const nanoVariantEnabled = showNanoVariant();
  const headerText = t('membership_includes');
  const multiDogHouseholdDiscountEnabled = useSelector(
    (state: types.AppState) => state.config.siteConfig.multiDogHouseholdDiscountEnabled ?? false,
  );

  return (
    <div className={styles.valuePropsSection}>
      {!nanoVariantEnabled && (
        <ValuePropsBox
          header={<div className={styles.subSectionHeader}>{headerText}</div>}
          valueProps={[
            {
              icon: <IconWarranty />,
              text: (
                <div className={styles.valueProp}>
                  <span className={styles.valuePropHeader}>
                    <span className={styles.valuePropHeaderBold}>
                      {t('fi_series_3_warranty_with_unlimited_replacements_on_active_memberships')}
                    </span>
                  </span>
                </div>
              ),
            },
            {
              icon: <IconMessage />,
              text: (
                <div className={styles.valueProp}>
                  <div className={styles.valuePropHeader}>
                    <span className={styles.valuePropHeaderBold}>
                      {t('7_days_a_week_customer_service_with_email_and_live_chat_support')}
                    </span>
                  </div>
                </div>
              ),
            },
            {
              icon: <IconPhone />,
              text: (
                <div className={styles.valueProp}>
                  <span className={styles.valuePropHeader}>
                    <span className={styles.valuePropHeaderBold}>{t('premium_phone_support_with_all_plans')}</span>
                  </span>
                </div>
              ),
            },
          ]}
        />
      )}
      {!inAppManagementVariant && multiDogHouseholdDiscountEnabled && (
        <>
          <div className={styles.multipleDogsHeader}>{t('have_multiple_dogs')}</div>
          <div className={styles.multipleDogsDescription}>
            {t('get_5_percent_off_all_fi_memberships_no_activation_fee')}
          </div>
        </>
      )}
    </div>
  );
}
